import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const trialBalanceRoute: RouteType = {
  name: "Trial Balance",
  path: "/accounting/reports/trial-balance",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Trial Balance",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./TrialBalance.Header"),
    },
    body: {
      component: () => import("./TrialBalance.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load chart of accounts and journal entries for trial balance calculation
    const coaStore = rootStore.chartOfAccountsStore as any;
    const jeStore = rootStore.journalEntriesStore as any;

    await Promise.all([
      coaStore.find({}),
      jeStore.find({ status: "posted" }), // Only posted entries affect trial balance
    ]);

    return true;
  },
};

export default trialBalanceRoute;
